import React         from 'react';
import { Userpilot } from 'userpilot';

export enum USERPILOT_EXPERIENCES {
	RESOURCE_CENTER                       = 'Sr3G26T',
	HIRING_MANAGER_SUMMARY_LEARN_MORE     = '1624130197sFzu412',
	BUDGET_BY_HIRE_SUMMARY_LEARN_MORE     = '1624132401cEug4453',
	BUDGET_BY_CATEGORY_SUMMARY_LEARN_MORE = '1624126063wVnq6867',
}

interface useUserPilotToolsHook {
	
	/* Method to call specific experiences */
	trigger( triggerId: USERPILOT_EXPERIENCES ): void,
}

export const trigger = ( triggerId: USERPILOT_EXPERIENCES ): void => {
	
	try{
		
		if( Userpilot && Userpilot?.trigger ){
			
			Userpilot.trigger( triggerId );
		}
		
	} catch( e ){
		
		// ..
	}
}

export const useUserPilotTools = (): useUserPilotToolsHook => {
	
	return {
		trigger,
	}
};
